
import Vue from 'vue';
import { ROUTER } from '@/router/constants';
import { mapActions, mapState } from 'vuex';
import { DAILY_FREE_RUNNIT_TOKENS_BASE, DAILY_FREE_RUNNIT_TOKENS_CAP } from '@run-diffusion/shared';

export default Vue.extend({
	name: 'RunnitFaqs',
	data () {
		return {
			ROUTER,
			DAILY_FREE_RUNNIT_TOKENS_CAP,
			DAILY_FREE_RUNNIT_TOKENS_BASE,
		};
	},
	computed: {
		...mapState([
			'runnitState',
		]),
	},
	methods: {
		...mapActions([
			'setUpsellDialog',
			'goToStripeSubscriptionPortal',
		]),
		onOpenRunnitPlanDetailDialog () {
			this.setUpsellDialog({
				runnitPlanDetailsData: {
					open: true,
				},
			});
		},
	},
});
